import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Inject, Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { Observable, of } from "rxjs";
import { concatMap } from "rxjs/operators";

import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from "@azure/msal-angular";
import { AccountInfo } from "@azure/msal-browser";

import { BaseGuard } from "@app/guards/base.guard";
import { checkGroupsInStorage, getGroupsFromStorage } from "@app/utils/storage-utils";
import { AlertService } from '@app/modules/alert';
import { getCurrentUserFromStorage} from "@app/utils/storage-utils";

//--import { GlobalService } from '@app-services/global.services';
import { GraphService } from '@app-services/graph.service';
import { GlobalConstants } from '@app-utils/global-constants';

type AccountWithGroupClaims = AccountInfo & {
    idTokenClaims?: {
        groups?: string[],
        _claim_names?: {
            groups?: string | string[]
        },
        _claim_sources?: {
            src1?: {
                endpoint: string | string[]
            }
        }
    }
}

@Injectable()
export class GroupGuard extends BaseGuard {

    constructor(
        @Inject(MSAL_GUARD_CONFIG) protected override msalGuardConfig: MsalGuardConfiguration,
        protected override msalBroadcastService: MsalBroadcastService,
        protected override authService: MsalService,
        protected override location: Location,
        protected override router: Router,
        private alertService: AlertService,
        private graphService: GraphService,
        //--private globalService: GlobalService,
    ) {
        super(msalGuardConfig, msalBroadcastService, authService, location, router,);
    }

    override activateHelper(state?: RouterStateSnapshot, route?: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const result = super.activateHelper(state, route);
        //console.log('activateHelper');
        const requiredGroups: string[] = route ? route.data['requiredGroups'] : [];

        return result.pipe(
            concatMap(() => {
                let activeAccount = this.authService.instance.getActiveAccount() as AccountWithGroupClaims;

                if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
                    activeAccount = this.authService.instance.getAllAccounts()[0] as AccountWithGroupClaims;
                }

                // check either the ID token or a non-expired storage entry for the groups membership claim
                if (!activeAccount?.idTokenClaims?.groups && !checkGroupsInStorage(activeAccount)) {

                    if (activeAccount.idTokenClaims?._claim_names && activeAccount.idTokenClaims?._claim_names.groups) {
                        this.alertService.warn('You have too many group memberships. The application will now query Microsoft Graph to check if you are a member of any of the groups required.')
                        //window.alert('You have too many group memberships. The application will now query Microsoft Graph to check if you are a member of any of the groups required.');
                        return this.router.navigate(['/overage']);
                    }

                    this.alertService.error("You do not have access to this function.  Please contact Supply Ontario IT support to gain appropriate access.")
                    
                    //window.alert('Token does not have groups claim. Please ensure that your account is assigned to a security group and then sign-out and sign-in again.');
                    return of(false);
                }

                const hasRequiredGroup = requiredGroups.some((group: string) =>
                    activeAccount?.idTokenClaims?.groups?.includes(group) || getGroupsFromStorage(activeAccount)?.includes(group)
                );

                if (!hasRequiredGroup) {
                    this.alertService.error('You do not have access to this function. Please contact Supply Ontario IT support to gain appropriate access(2).');
                    //window.alert('You do not have access. Please ensure that your account is assigned to the required security group and then sign-out and sign-in again.');
                }

                if (activeAccount && getCurrentUserFromStorage() == GlobalConstants.noLoggedInUser) {
                    this.getCurrentUser();
                }

                return of(hasRequiredGroup);
            })
        );
    }

    //this request puts the current user in storage within service call.
    async getCurrentUser() {
        const currentUser = await  this.graphService.getCurrentUser();
        //--this.globalService.setCurrentUser(currentUser);
       // setCurrentUserInStorage(currentUser);
       // console.log(currentUser);


    }

}